import { useEffect, useRef, useState } from "react";
import { db, functions } from "../firebase";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { auth } from "../firebase";
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, query, orderBy, limit, startAfter, where } from "firebase/firestore";
import { runTransaction } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { sendBrevoMail } from "../sendBrevoMail";
import { formatWarehouse, parseWarehouseDateTime, warehouseSlotKey } from "../warehouseTime";
import {
  updatePreAlert,
  updateTitle,
  updatePreAlerts,
  updatePreAlertID,
} from "../features/counter/counterSlice";
import {
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalBody,
} from "reactstrap";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

// Helper function to safely convert date to milliseconds
const getDateMs = (date) => {
  try {
    if (typeof date === 'string') {
      const ms = new Date(date).getTime();
      return isNaN(ms) ? null : ms;
    } else if (date && date.seconds) {
      return date.seconds * 1000 + (date.nanoseconds || 0) / 1000000;
    } else if (date instanceof Date) {
      return date.getTime();
    }
    return null;
  } catch (e) {
    return null;
  }
};

function PreAlertManagment() {
  const [filteredPreAlerts, setFilteredPreAlerts] = useState();
  const [lastVisible, setLastVisible] = useState(null);
  const preAlert = useSelector((state) => state.store.preAlert);
  const preAlerts = useSelector((state) => state.store.preAlerts);
  const title = useSelector((state) => state.store.title);
  const [unitsTotal, setUnitsTotal] = useState(0);
  const [palletsTotal, setPalletsTotal] = useState(0);
  const [preAlertHeight, setPreAlertHeight] = useState(0);
  const dispatch = useDispatch();
  const [fields, setFields] = useState(0);
  const [isCanceled, setIsCanceled] = useState(false);
  const navigate = useNavigate();

  const [objectValue, setObjectValue] = useState({
    cars: [
      { receiving: "", id: 1, quantity: 0, palletsNumber: 0, numberFBA: "" },
      { receiving: "", id: 2, quantity: 0, palletsNumber: 0, numberFBA: "" },
    ],
  });

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user.displayName === "porter") {
        navigate("/super-admin/parking-map");
      }
    });
  }, []);

  useEffect(() => {
    if (Object.keys(preAlert).length > 0) {
      // Tworzymy nowy stan na podstawie nowej długości tablicy samochodów w preAlert
      const initialCars = [];

      // Dodajemy nowe samochody na podstawie nowej długości tablicy samochodów w preAlert
      const additionalCarsCount = preAlert.cars.length;
      for (let i = 0; i < additionalCarsCount; i++) {
        initialCars.push({
          receiving: preAlert.cars[i].receiving,
          id: initialCars.length + 1, // Nowy numer ID
          quantity: preAlert.cars[i].quantity,
          palletsNumber: preAlert.cars[i].palletsNumber,
          numberFBA: preAlert.cars[i].numberFBA,
        });
      }

      // Aktualizujemy stan objectValue na podstawie nowej tablicy samochodów
      setObjectValue({ cars: initialCars });
    }
  }, [preAlert]);

  const [wantedAlert, setWantedAlert] = useState("");
  const [emailValidate, setEmailValidate] = useState(true);
  const autoLoadAttemptsRef = useRef(0);
  const [isAutoLoading, setIsAutoLoading] = useState(false);

  // Auto-search as user types
  useEffect(() => {
    const runSearch = async () => {
      const term = (wantedAlert || "").trim();

      // Reset prób autoładowania przy zmianie frazy
      if (!isAutoLoading) {
        autoLoadAttemptsRef.current = 0;
      }

      // Brak frazy => pokaż załadowane pozycje
      if (!term) {
        setFilteredPreAlerts(preAlerts);
        return;
      }

      // Jeśli fraza to czysta liczba, spróbuj szybkie wyszukiwanie po polu `id` w Firestore
      if (/^\d+$/.test(term)) {
        try {
          const alertsCollectionRef = collection(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts');
          const idNumber = parseInt(term, 10);
          const q = query(alertsCollectionRef, where('id', '==', idNumber), limit(5));
          const snap = await getDocs(q);
          const list = [];
          snap.forEach((docSnap) => list.push({ docId: docSnap.id, ...docSnap.data() }));
          if (list.length > 0) {
            setFilteredPreAlerts(list);
            return;
          }
          // Jeśli nic nie znaleziono w Firestore, spadamy do lokalnego filtra
        } catch (e) {
          console.error('Quick Firestore ID search error:', e);
        }
      }

      // Lokalny filtr po obecnie załadowanych elementach
      const found = (preAlerts || []).filter((alert) => {
        const preAlertId = `Pre-Alert no #${alert.id}`.toLowerCase();
        const from = alert.from ? alert.from.toLowerCase() : "";
        const numberFBA1 = alert.cars && alert.cars[0] ? alert.cars[0].numberFBA || "" : "";
        const numberFBA2 = alert.cars && alert.cars[1] ? alert.cars[1].numberFBA || "" : "";

        return (
          preAlertId.includes(term.toLowerCase()) ||
          from.includes(term.toLowerCase()) ||
          numberFBA1.includes(term) ||
          numberFBA2.includes(term)
        );
      });
      setFilteredPreAlerts(found);

      // Jeśli nie znaleziono nic albo bardzo mało, automatycznie dociągaj kolejne strony do rozsądnego limitu
      if (term && lastVisible && found.length === 0 && autoLoadAttemptsRef.current < 10 && !isAutoLoading) {
        setIsAutoLoading(true);
        try {
          autoLoadAttemptsRef.current += 1;
          await fetchMoreAlerts();
        } finally {
          setIsAutoLoading(false);
        }
      }
    };

    runSearch();
  }, [wantedAlert, preAlerts, lastVisible]);

// NOWA WERSJA getAlerts Z PAGINACJĄ
const getAlerts = async () => {
  try {
    const alertsCollectionRef = collection(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts');
    
    // Tworzymy zapytanie: sortuj po 'id' malejąco i weź tylko pierwsze 100
    const q = query(alertsCollectionRef, orderBy("id", "desc"), limit(100));

    const documentSnapshots = await getDocs(q);

    const alertsList = [];
    documentSnapshots.forEach((doc) => {
      const data = doc.data();
      if (data.firstDate && data.firstDate.toDate) {
        try {
          const dateObj = data.firstDate.toDate();
          if (dateObj && !isNaN(dateObj.getTime())) {
            data.firstDate = dateObj.toISOString();
          }
        } catch (e) {
          console.warn('Failed to convert firstDate:', e);
        }
      }
      alertsList.push({ docId: doc.id, ...data });
    });
    
    // Zapisujemy ostatni widoczny dokument, aby wiedzieć od czego zacząć następnym razem
    const lastDoc = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    setLastVisible(lastDoc);

    dispatch(updatePreAlerts(alertsList));

  } catch (error) {
    console.error("Error fetching initial alerts: ", error);
  }
};

// NOWA FUNKCJA DO WCZYTYWANIA WIĘCEJ DANYCH
const fetchMoreAlerts = async () => {
  if (!lastVisible) {
    console.log("No more documents to load.");
    return;
  }
  try {
    const alertsCollectionRef = collection(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts');
    
    // Zapytanie: sortuj po 'id' i zacznij PO ostatnim dokumencie, który widzieliśmy
    const q = query(alertsCollectionRef, orderBy("id", "desc"), startAfter(lastVisible), limit(100));

    const documentSnapshots = await getDocs(q);
    
    const newAlertsList = [];
    documentSnapshots.forEach((doc) => {
      const data = doc.data();
      if (data.firstDate && data.firstDate.toDate) {
        try {
          const dateObj = data.firstDate.toDate();
          if (dateObj && !isNaN(dateObj.getTime())) {
            data.firstDate = dateObj.toISOString();
          }
        } catch (e) {
          console.warn('Failed to convert firstDate in pagination:', e);
        }
      }
      newAlertsList.push({ docId: doc.id, ...data });
    });

    const lastDoc = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    setLastVisible(lastDoc);

    // Dodajemy nowe alerty do już istniejących w Reduxie
    dispatch(updatePreAlerts([...preAlerts, ...newAlertsList]));

  } catch (error) {
    console.error("Error fetching more alerts: ", error);
  }
};


  useEffect(() => {
    getAlerts();
  }, []);

  useEffect(() => {
    if(objectValue.type !== 'loose'){
      setObjectValue((prevState) => {
        // Only update if trailerType is not already empty
        if (prevState.trailerType !== '') {
          return {
            ...prevState,
            trailerType: '',
          };
        }
        return prevState;
      });
    }
  }, [objectValue.type])

  const checkTable = () => {
    const inputs = document.querySelectorAll("#amazon-table input");
    const inputsArray = Array.from(inputs);
    const chunks = [];
    const chunkSize = 4;

    for (let i = 0; i < inputsArray.length; i += chunkSize) {
      const chunk = inputsArray.slice(i, i + chunkSize);
      chunks.push(chunk);
    }

    chunks.forEach((chunk, index) => {
      if (index !== 0) {
        const allEmpty = chunk.every((field) => field.value === ""); // Sprawdzamy, czy wszystkie elementy w rzędzie są puste
        if (allEmpty) {
          chunk.forEach((field) => {
            field.classList.remove("error"); // Usuwamy klasę error z każdego elementu w rzędzie
          });
        }
      }
    });
  };

// NOWA I KOMPLETNA WERSJA sendPreAlert
const sendPreAlert = async () => {
  checkForm();
  checkTable();

  const tableFields = document.querySelectorAll(
    "#amazon-table input[required]"
  );
  for (let i = 0; i < tableFields.length; i++) {
    if (tableFields[i].value === "") {
      openToast("Please complete all fields");
      return;
    }
  }

  // Prawidłowa sekcja walidacji
  const {
    email,
    firstDate,
    from,
    phoneNumber,
    trailerPlates,
    type,
    swapbodyPlates,
    sealNumber,
  } = objectValue;

  if (
    !email || !firstDate || !from || !phoneNumber || !trailerPlates ||
    (type === "swapbody" || type === "trailer" ? !swapbodyPlates : false) ||
    !type || !sealNumber
  ) {
    openToast("Please complete all fields");
    return;
  }
  
  // Prepare data for Cloud Function
  const parsedFirstDate = parseWarehouseDateTime(objectValue.firstDate);
  const reservationData = {
    type: objectValue.type,
    firstDate: parsedFirstDate ? parsedFirstDate.toISOString() : objectValue.firstDate,
    email: objectValue.email,
    from: objectValue.from,
    phoneNumber: objectValue.phoneNumber,
    cars: objectValue.cars,
    trailerPlates: objectValue.trailerPlates,
    swapbodyPlates: objectValue.swapbodyPlates || '',
    swapbodyPlates2: objectValue.swapbodyPlates2 || '',
    sealNumber: objectValue.sealNumber,
    sealNumber2: objectValue.sealNumber2 || '',
    trailerType: objectValue.trailerType || '',
    siteName: process.env.REACT_APP_SITE_NAME || "Inbound appointment Slam Hoyerswerda",
    cancellation_token: uuidv4(),
  };

  try {
    // Call secure Cloud Function
    const createSecureReservation = httpsCallable(functions, 'createSecureReservation');
    const result = await createSecureReservation(reservationData);
    
    const newId = result.data.id;
    const newDocRef = { id: result.data.docId };
    const newAlertData = { ...reservationData, id: newId, cancellation_token: reservationData.cancellation_token };

    // Przygotuj e-mail z pełną treścią
    const dateForEmail = formatWarehouse(newAlertData.firstDate, 'yyyy-MM-dd HH:mm');
    
    // Dynamiczny link w zależności od lokacji
    const siteName = process.env.REACT_APP_SITE_NAME || "Inbound appointment Slam Hoyerswerda";
    const cancelBookingDomain = siteName.includes("Oschatz") 
      ? "https://oschatz.slamwarehouse.com" 
      : "https://hoyerswerda.slamwarehouse.com";
    
    const emailData = {
      email: newAlertData.email,
      id: newId,
      from: siteName.includes("Oschatz") ? "slamfirebaseproject@gmail.com" : "slamhoyerswerda@gmail.com",
      my_html: `<h3>Pre-Alert no #${newId}</h3><br/><br/><p>Dear User,</p><p>We would like to inform you that the pre-alert date has been set for <strong>${dateForEmail}</strong>. If you have any questions, please contact our customer support team.</p><br/>
        <table className="table table-striped">
          <thead>
            <tr>
              <th style='text-align: start;margin: 15px;'>Receiving AMAZON-FC</th>
              <th style='text-align: start;margin: 15px;'>FBA-Number</th>
              <th style='text-align: start;margin: 15px;'>Quantity of units</th>
              <th style='text-align: start;margin: 15px;'>No of pallets</th>
            </tr>
          </thead>
          <tbody>
            ${newAlertData.cars.map(car => `
              <tr>
                <th style='text-align:start;margin: 15px;' scope="row">${car.receiving || ''}</th>
                <td style='text-align:start;margin: 15px;'>${car.numberFBA || ''}</td>
                <td style='text-align:start;margin: 15px;'>${car.quantity === 0 ? "" : car.quantity}</td>
                <td style='text-align:start;margin: 15px;'>${car.palletsNumber === 0 ? "" : car.palletsNumber}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
        <p>If you want to cancel this booking, please click the link below:</p>
        <a href="${cancelBookingDomain}/cancel-booking/${newDocRef.id}/${newAlertData.cancellation_token}">Cancel Booking</a>
        <p>Best regards,<br>Slam Poland</p>`,
    };

    try {
      await sendBrevoMail(emailData);
    } catch (mailErr) {
      console.warn('E-mail sending failed (non-blocking):', mailErr);
      openToast('Pre-alert saved, but failed to send the confirmation e-mail.');
      setTimeout(() => window.location.reload(), 2500);
      return;
    }

    openToast2("Pre-alert has been sent");
    setTimeout(() => window.location.reload(), 1500);

  } catch (error) {
    console.error("Error sending pre-alert:", error);
    openToast(error?.message || "Failed to send pre-alert. Please try again.");
  }
};

  const handleUpdate = (e, index) => {
    if (
      e.target.name === "receiving" ||
      e.target.name === "numberFBA" ||
      e.target.name === "quantity" ||
      e.target.name === "palletsNumber"
    ) {
      const { name, value } = e.target;
      const updatedCars = [...objectValue.cars];

      if (name === "quantity" || name === "palletsNumber") {
        updatedCars[index - 1][name] = value === "" ? 0 : value;
      } else {
        updatedCars[index - 1][name] = value;
      }
      setObjectValue({ ...objectValue, cars: updatedCars });
    } else {
      setObjectValue((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const carsHandleUpdate = (e, index) => {
    const { name, value } = e.target;
    const updatedCars = [...objectValue.cars];
    updatedCars[index][name] =
      name === "quantity" || name === "palletsNumber"
        ? value === ""
          ? 0
          : value
        : value;
    setObjectValue({ ...objectValue, cars: updatedCars });
  };
/**
 * Uniwersalna funkcja do aktualizacji pojedynczego dokumentu pre-alertu.
 * @param {string} docId - ID dokumentu do zaktualizowania.
 * @param {object} dataToUpdate - Obiekt z polami, które mają być zmienione.
 */
const updateAlertInDB = async (docId, dataToUpdate) => {
  if (!docId) {
    console.error("Brak docId! Nie można zaktualizować alertu.");
    toast.error("Error: Alert ID is missing.");
    throw new Error("Alert ID is missing");
  }
  try {
    const docRef = doc(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'alerts', docId);
    await updateDoc(docRef, dataToUpdate);
    console.log(`Dokument ${docId} zaktualizowany pomyślnie.`);
  } catch (error) {
    console.error("Błąd podczas aktualizacji dokumentu:", docId, error);
    toast.error("Error updating pre-alert.");
    throw error;
  }
};

const handleUpdatePreAlert = async () => {
    if (!preAlert || !preAlert.docId) {
        openToast('Please select the pre-alert to be updated');
        return;
    }

    // Zbierz wszystkie dane z formularza do jednego obiektu
    const dataForUpdate = {
        ...objectValue, // Wszystkie pola z formularza
    };
    
    // Jeśli data została zmieniona, przekonwertuj ją na obiekt Date
    if (dataForUpdate.firstDate && typeof dataForUpdate.firstDate === 'string') {
        dataForUpdate.firstDate = parseWarehouseDateTime(dataForUpdate.firstDate);
    }
    for (const field of ['arrivalDate', 'unloadingDate', 'departureDate']) {
        if (dataForUpdate[field] && typeof dataForUpdate[field] === 'string') {
            dataForUpdate[field] = parseWarehouseDateTime(dataForUpdate[field]);
        }
    }
    
    try {
        await updateAlertInDB(preAlert.docId, dataForUpdate);
        // Opcjonalnie wyślij maila o zmianie
        window.location.reload();
    } catch (error) {
        // Błąd jest już obsłużony w updateAlertInDB, więc nic więcej nie trzeba robić
    }
};

// async function deleteRecord() {
//   const index = preAlerts.findIndex(obj => obj.id === preAlert.id);
  
//   if (index === -1) {
//     console.error("Pre-alert not found");
//     return; // Zakończ funkcję, jeśli nie znaleziono pre-alert
//   }

//   const alerts = Array.from(preAlerts);
//   alerts.splice(index, 1); // Usunięcie pre-alert

//   try {
//     const docRef = doc(db, 'pre-alerts', 'euoso0pRR5PZw2wBnjOW'); // Tworzenie referencji do dokumentu
//     await updateDoc(docRef, { alerts: alerts }); // Aktualizacja dokumentu
//     window.location.reload(); // Odświeżenie strony
//   } catch (error) {
//     console.error("Error updating document:", error); // Obsługa błędu
//   }
// }

  const openToast = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.error(message, {
        position: "top-center",
      });
    }
  };

  const openToast2 = (message) => {
    const Toastify__toast = document.querySelector(".Toastify__toast ");
    if (Toastify__toast === null) {
      toast.success(message, {
        position: "top-center",
      });
    }
  };

const handleCancel = async () => {
  if (isCanceled) {
    return;
  }
  if (!preAlert || !preAlert.docId) {
    openToast("Please select the pre-alert to be canceled");
    return;
  }
  if (!objectValue.nameAndSurname) {
    openToast("Please enter your first and last name");
    return;
  }

  setIsCanceled(true);

  try {
    await updateAlertInDB(preAlert.docId, { isCancel: true });

    try {
      if (preAlert && preAlert.firstDate) {
        const slotKey = warehouseSlotKey(preAlert.firstDate);
        const lockRef = doc(db, 'pre-alerts_MIGRATED', 'euoso0pRR5PZw2wBnjOW', 'locks', slotKey);
        await runTransaction(db, async (tx) => {
          const snap = await tx.get(lockRef);
          if (!snap.exists()) return;
          const count = snap.data().count || 0;
          if (count <= 1) {
            tx.delete(lockRef);
          } else {
            tx.update(lockRef, { count: count - 1, updatedAt: Date.now() });
          }
        });
      }
    } catch (unlockErr) {
      console.warn('Unlock slot on cancel failed (non-critical):', unlockErr);
    }

    try {
      // Konwertuj firstDate - może być Timestamp lub ISO string
      let dateMs;
      if (preAlert.firstDate && preAlert.firstDate.seconds) {
        // Firestore Timestamp
        dateMs = preAlert.firstDate.seconds * 1000 + (preAlert.firstDate.nanoseconds || 0) / 1000000;
      } else if (preAlert.firstDate && typeof preAlert.firstDate === 'string') {
        // ISO string
        dateMs = new Date(preAlert.firstDate).getTime();
      } else if (preAlert.firstDate instanceof Date) {
        // Date object
        dateMs = preAlert.firstDate.getTime();
      } else {
        dateMs = Date.now();
      }
      
      const date = formatWarehouse(new Date(dateMs), 'yyyy-MM-dd HH:mm');
      const siteName = process.env.REACT_APP_SITE_NAME || "Inbound appointment Slam Hoyerswerda";
      const emailObj = {
        email: preAlert.email,
        id: preAlert.id || preAlert.docId,
        from: siteName.includes("Oschatz") ? "slamfirebaseproject@gmail.com" : "slamhoyerswerda@gmail.com",
        my_html: `<h3>Pre Alert no #${preAlert.id || preAlert.docId}</h3><br/><br/><p>Dear User,</p><p>We want to inform you that the pre-alert with date <strong>${date}</strong> has been canceled. All necessary steps have been taken to ensure continuity of operations according to our plans.</p><p>Thank you for your patience and cooperation throughout this process. Please feel free to contact our customer support department if you have any questions or concerns.</p><p>Best regards,</p><p>Slam Poland</p>`,
      };
      await sendBrevoMail(emailObj);
    } catch (emailError) {
      console.error("BŁĄD WYSYŁKI MAILA:", emailError);
      openToast('Alert was canceled, but failed to send the confirmation email.');
    }

    openToast2('Pre-alert has been successfully canceled.');
    setOpen(false);
    setTimeout(() => window.location.reload(), 1500);

  } catch (dbError) {
    console.error("Błąd podczas anulowania w bazie danych:", dbError);
    openToast('Failed to cancel the pre-alert. Please try again.');
    setIsCanceled(false);
  }
};
const handleMarkAsRealized = async () => {
  if (!preAlert || !preAlert.docId) {
    openToast('Please select a pre-alert first.');
    return;
  }
  try {
    await updateAlertInDB(preAlert.docId, { manualStatus: 'realized' });
    window.location.reload();
  } catch (error) {
    openToast('Failed to update status.');
  }
};

const handleMarkAsNotArrived = async () => {
  if (!preAlert || !preAlert.docId) {
    openToast('Please select a pre-alert first.');
    return;
  }
  try {
    await updateAlertInDB(preAlert.docId, { manualStatus: 'notArrived' });
    window.location.reload();
  } catch (error) {
    openToast('Failed to update status.');
  }
};

  // Obsługa Enter w polu wyszukiwania przeniesiona do React event handlera

  function checkForm() {
    const inputs = document.querySelectorAll("input[required]");
    const select = document.querySelector("select[required]");
    const textarea = document.querySelector("textarea[required]");
    let input; // Deklaracja zmiennej dla email check poniżej

    if (textarea) {
      if (textarea.value.trim() === "") {
        textarea.classList.add("error");
      } else {
        textarea.classList.remove("error");
      }
    }

    if (select) {
      if (select.value.trim() === "") {
        select.classList.add("error");
      } else {
        select.classList.remove("error");
      }
    }

    inputs.forEach(function (inputItem) {
      if (inputItem.value.trim() === "") {
        inputItem.classList.add("error");
      } else {
        inputItem.classList.remove("error");
      }
      // Zachowaj referencję do email input
      if (inputItem.name === "email") {
        input = inputItem;
      }
    });

    if (input && input.name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validate = emailRegex.test(input.value);
      if (validate) {
        input.classList.remove("error");
        setEmailValidate(validate);
      } else {
        input.classList.add("error");
        setEmailValidate(validate);
      }
    }
  }

  function checkIndividualForm(e) {
    if (e.target.value !== "") {
      e.target.classList.remove("error");
    }
  }

  function checkIndividualEmailValidate(e) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validate = emailRegex.test(e.target.value);
    if (validate) {
      e.target.classList.remove("error");
      setEmailValidate(validate);
    } else {
      e.target.classList.add("error");
      setEmailValidate(validate);
    }
  }

  useEffect(() => {
    if (objectValue.cars && objectValue.cars.length > 0) {
      const totalQuantity = objectValue.cars.reduce((accumulator, car) => {
        const qty = parseInt(car.quantity) || 0;
        const acc = parseInt(accumulator) || 0;
        return acc + qty;
      }, 0);
      setUnitsTotal(totalQuantity || 0);
      
      const totalPallets = (
        objectValue.cars ? objectValue.cars : preAlert.cars || []
      ).reduce((accumulator, car) => {
        const pallets = parseInt(car.palletsNumber) || 0;
        const acc = parseInt(accumulator) || 0;
        return acc + pallets;
      }, 0);
      setPalletsTotal(totalPallets || 0);
    }
  }, [objectValue, preAlert]);

  const openModal = () => {
    if (Object.keys(preAlert).length > 0) {
      setOpen(!open);
    } else {
      openToast("Please select pre-alert");
    }
  };

  const rejectionEmail = () => {
    checkForm();
    if (
      objectValue.nameAndSurname !== undefined &&
      objectValue.nameAndSurname !== ""
    ) {
      const index = preAlerts.findIndex((obj) => obj === preAlert);
      
      // Bezpieczna konwersja firstDate
      let colonIndex = -1;
      try {
        let firstDateMs;
        if (typeof preAlert.firstDate === 'string') {
          firstDateMs = new Date(preAlert.firstDate).getTime();
        } else if (preAlert.firstDate && preAlert.firstDate.seconds) {
          firstDateMs = preAlert.firstDate.seconds * 1000 + (preAlert.firstDate.nanoseconds || 0) / 1000000;
        } else if (preAlert.firstDate instanceof Date) {
          firstDateMs = preAlert.firstDate.getTime();
        } else {
          firstDateMs = null;
        }
        if (firstDateMs && !isNaN(firstDateMs)) {
          colonIndex = new Date(firstDateMs + 3600000).toISOString().lastIndexOf(":");
        }
      } catch (e) {
        console.warn('Failed to parse firstDate:', e);
      }
      
      // Bezpieczna konwersja arrivalDate
      let colonIndex4 = -1;
      try {
        if (preAlert.arrivalDate && preAlert.arrivalDate.seconds) {
          colonIndex4 = new Date(
            preAlert.arrivalDate.seconds * 1000 +
              preAlert.arrivalDate.nanoseconds / 1000000 +
              3600000
          ).toISOString().lastIndexOf(":");
        }
      } catch (e) {
        console.warn('Failed to parse arrivalDate:', e);
      }
      
      // Bezpieczna konwersja unloadingDate
      let colonIndex2 = -1;
      try {
        if (preAlert.unloadingDate && preAlert.unloadingDate.seconds) {
          colonIndex2 = new Date(
            preAlert.unloadingDate.seconds * 1000 +
              preAlert.unloadingDate.nanoseconds / 1000000 +
              3600000
          ).toISOString().lastIndexOf(":");
        }
      } catch (e) {
        console.warn('Failed to parse unloadingDate:', e);
      }
      
      // Bezpieczna konwersja departureDate
      let colonIndex3 = -1;
      try {
        if (preAlert.departureDate && preAlert.departureDate.seconds) {
          colonIndex3 = new Date(
            preAlert.departureDate.seconds * 1000 +
              preAlert.departureDate.nanoseconds / 1000000 +
              3600000
          ).toISOString().lastIndexOf(":");
        }
      } catch (e) {
        console.warn('Failed to parse departureDate:', e);
      }

      const carsDataString = objectValue.cars
        .map(
          (car, carIndex) =>
            `${
              car.receiving !== "" && car.receiving !== undefined
                ? car.receiving
                : preAlerts[index].cars[carIndex].receiving
            } ${
              car.numberFBA !== "" && car.numberFBA !== undefined
                ? car.numberFBA
                : preAlerts[index].cars[carIndex].numberFBA
            } ${
              car.quantity !== 0 && car.quantity !== undefined
                ? car.quantity
                : preAlerts[index].cars[carIndex].quantity
            } ${
              car.palletsNumber !== 0 && car.palletsNumber !== undefined
                ? car.palletsNumber
                : preAlerts[index].cars[carIndex].palletsNumber
            }`
        )
        .join("\n");

      const message =
        "Hello,\n\n" +
        `Pre-Alert no #${preAlerts[index].id}\n` +
        `From: ${
          objectValue.from !== "" && objectValue.from !== undefined
            ? objectValue.from
            : preAlerts[index].from
        }\n` +
        `Email: ${
          objectValue.email !== "" && objectValue.email !== undefined
            ? objectValue.email
            : preAlerts[index].email
        }\n` +
        `Phone number: ${
          objectValue.phoneNumber !== "" &&
          objectValue.phoneNumber !== undefined
            ? objectValue.phoneNumber
            : preAlerts[index].phoneNumber
        }\n` +
        `Type of vehicle: ${
          objectValue.type !== "" && objectValue.type !== undefined
            ? objectValue.type
            : preAlerts[index].type
        }\n` +
        `Truck plates: ${
          objectValue.trailerPlates !== "" &&
          objectValue.trailerPlates !== undefined
            ? objectValue.trailerPlates
            : preAlerts[index].trailerPlates
        }\n` +
        `Trailer type: ${
          objectValue.trailerType !== "" &&
          objectValue.trailerType !== undefined
            ? objectValue.trailerType
            : preAlerts[index].trailerType
        }\n` +
        `Trailer plate/swapbody #1: ${
          objectValue.swapbodyPlates !== "" &&
          objectValue.swapbodyPlates !== undefined
            ? objectValue.swapbodyPlates
            : preAlerts[index].swapbodyPlates
        }\n` +
        `Swabody #2: ${
          objectValue.swapbodyPlates2 !== undefined
            ? objectValue.swapbodyPlates2
            : preAlerts[index].swapbodyPlates2 === undefined
            ? ""
            : preAlerts[index].swapbodyPlates2
        }\n` +
        `Delivery date: ${
          objectValue.firstDate !== "" && objectValue.firstDate !== undefined
            ? new Date(objectValue.firstDate)
            : (() => {
                const ms = getDateMs(preAlert.firstDate);
                return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "N/A";
              })()
        }\n` +
        `Seal number #1: ${
          objectValue.sealNumber !== "" && objectValue.sealNumber !== undefined
            ? objectValue.sealNumber
            : preAlerts[index].sealNumber
        }\n` +
        `Seal number #2: ${
          objectValue.sealNumber2 !== undefined
            ? objectValue.sealNumber2
            : preAlerts[index].sealNumber2 === undefined
            ? ""
            : preAlerts[index].sealNumber2
        }\n` +
        `Receiving   FBA Number   Quantity   Pallets Number\n` +
        `${carsDataString}\n` +
        +"\n\n" +
        `Name and surname: ${objectValue.nameAndSurname}\n` +
        `Arrival date: ${(() => {
          const ms = getDateMs(preAlert.arrivalDate);
          return ms && colonIndex4 > 0 ? new Date(ms + 3600000).toISOString().replace("T", " ").slice(0, colonIndex4) : "N/A";
        })()}\n` +
        `Start of unloading: ${(() => {
          const ms = getDateMs(preAlert.unloadingDate);
          return ms && colonIndex2 > 0 ? new Date(ms + 3600000).toISOString().replace("T", " ").slice(0, colonIndex2) : "N/A";
        })()}\n` +
        `Cancelation of unloading: ${(() => {
          const ms = getDateMs(preAlert.unloadingDate);
          return ms && colonIndex2 > 0 ? new Date(ms + 3600000).toISOString().replace("T", " ").slice(0, colonIndex2) : "N/A";
        })()}\n` +
        `Departure date: ${(() => {
          const ms = getDateMs(preAlert.departureDate);
          return ms && colonIndex3 > 0 ? new Date(ms + 3600000).toISOString().replace("T", " ").slice(0, colonIndex3) : "N/A";
        })()}\n` +
        `Comment: ${objectValue.comment}\n` +
        +"\n\n" +
        "Best regards,\nSlam Poland";
      // Koduj treść wiadomości dla mailto
      const encodedMessage = encodeURIComponent(message);
      const mailtoLink =
        "mailto:adres@adres.com?subject=Odrzucenie%20zapytania&body=" +
        encodedMessage;
      window.location.href = mailtoLink;
      window.location.reload();
    } else {
      openToast("Please enter your first and last name");
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(!open);

  const addCar = () => {
    setObjectValue((prevState) => {
      const newCar = {
        id: prevState.cars.length + 1,
        receiving: "",
        numberFBA: "",
        quantity: 0,
        palletsNumber: 0,
      };
      return {
        ...prevState,
        cars: [...prevState.cars, newCar],
      };
    });
  };

  const limitedFields = Math.min(fields, 38);

  useEffect(() => {
    const preAlertBox = document.querySelector('.pre-alert-box');
    
    if(preAlertBox) 
      setPreAlertHeight(preAlertBox.offsetHeight)
  }, [preAlert])

  return (
    <>
      <ToastContainer
        style={{ width: "800px", zIndex: 10000 }}
        autoClose={2000}
      />
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />

      <div
        className="content"
        style={{ display: "flex", flexFlow: "row nowrap" }}
      >
        <div
          className="bg-my-black"
          style={{ borderRadius: "8px", width: "20%", height: preAlertHeight, overflowY: "auto", border: "1px solid #333" }}
        >
          <div style={{ marginTop: "10px", padding: "0 10px" }}>
            <InputGroup className="no-border">
              <Input
                value={wantedAlert || ""}
                onChange={(e) => {
                  setWantedAlert(e.target.value || "");
                }}
                id="search"
                placeholder="Search pre-alerts"
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  style={{ backgroundColor: "white", cursor: "pointer" }}
                >
                  <i
                    style={{ color: "rgb(255, 193, 7)" }}
                    className="nc-icon nc-zoom-split"
                  />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
            {filteredPreAlerts
              ? filteredPreAlerts
                  .filter((a, i, arr) => {
                    const key = a.docId ?? a.id;
                    return key ? arr.findIndex(x => (x.docId ?? x.id) === key) === i : i === arr.findIndex(x => x === a);
                  })
                  .map((alert, index) => {
                  const deliveryDate = new Date(
                    alert.firstDate.seconds * 1000 +
                      alert.firstDate.nanoseconds / 1000000
                  );
                  const today = new Date();

                  return (
                    <div
                    key={alert.docId || alert.id || index}
                    // NOWA WERSJA LOGIKI KOLORÓW
                    style={{
                      ...(preAlert.id === alert.id
                      ? { backgroundColor: "#ffc107", color: "#000" } // Zawsze żółty dla aktywnego
                      : alert.isCancel === true
                      ? { backgroundColor: "#CC0C39", color: "#fff" } // Czerwony dla anulowanego
                      : alert.manualStatus === 'realized'
                      ? { backgroundColor: "#008000", color: "#fff" } // Zielony dla zrealizowanego
                      : alert.manualStatus === 'notArrived'
                      ? { backgroundColor: "#FFC0CB", color: "#000" } // Różowy dla nieprzybyłego
                      : deliveryDate < today && !alert.isRealized
                      ? { backgroundColor: "#0080ff", color: "#fff" } // Niebieski dla "po terminie" (jeśli nie ma innego statusu)
                      : alert.isChanged === true
                      ? { backgroundColor: "#ff8413", color: "#000" } // Pomarańczowy dla zmienionej daty
                      : { backgroundColor: "#ffffff", color: "#000" } // Domyślny
                    ),
                      padding: "8px 16px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ccc",
                      whiteSpace: "nowrap",
                    }}
                      onClick={() => {
                        dispatch(updateTitle(`Pre-Alert no #${alert.id}`));
                        dispatch(updatePreAlert(alert));
                        setObjectValue({
                          cars: [
                            {
                              type: "",
                              id: 1,
                              quantity: "",
                              palletsNumber: "",
                              numberFBA: "",
                              receiving: "",
                            },
                            {
                              receiving2: "",
                              type2: "",
                              id: 2,
                              quantity2: "",
                              palletsNumber2: "",
                              numberFBA2: "",
                            },
                          ],
                        });
                        setTimeout(checkForm, 100);
                      }}
                      className="list"
                    >
                      Pre-Alert no #{alert.id}
                    </div>
                  );
                })
              : preAlerts
              ? preAlerts
                  .filter((a, i, arr) => {
                    const key = a.docId ?? a.id;
                    return key ? arr.findIndex(x => (x.docId ?? x.id) === key) === i : i === arr.findIndex(x => x === a);
                  })
                  .map((alert, index) => {
                  const deliveryDate = new Date(
                    alert.firstDate.seconds * 1000 +
                      alert.firstDate.nanoseconds / 1000000
                  );
                  const today = new Date();

                  return (
                    <div
                    key={alert.docId || alert.id || index}
                      style={{
                      ...(preAlert.id === alert.id
                        ? { backgroundColor: "#ffc107", color: "#000" } // Zawsze żółty dla aktywnego
                        : alert.isCancel === true
                        ? { backgroundColor: "#CC0C39", color: "#fff" } // Czerwony dla anulowanego
                        : alert.manualStatus === 'realized'
                        ? { backgroundColor: "#008000", color: "#fff" } // Zielony dla zrealizowanego
                        : alert.manualStatus === 'notArrived'
                        ? { backgroundColor: "#FFC0CB", color: "#000" } // Różowy dla nieprzybyłego
                        : deliveryDate < today && !alert.isRealized
                        ? { backgroundColor: "#0080ff", color: "#fff" } // Niebieski dla "po terminie" (jeśli nie ma innego statusu)
                        : alert.isChanged === true
                        ? { backgroundColor: "#ff8413", color: "#000" } // Pomarańczowy dla zmienionej daty
                        : { backgroundColor: "#ffffff", color: "#000" } // Domyślny
                    ),
                      padding: "8px 16px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ccc",
                      whiteSpace: "nowrap",
                    }}
                      onClick={() => {
                        dispatch(updateTitle(`Pre-Alert no #${alert.id}`));
                        dispatch(updatePreAlert(alert));
                        setObjectValue({
                          cars: [
                            {
                              type: "",
                              id: 1,
                              quantity: "",
                              palletsNumber: "",
                              numberFBA: "",
                              receiving: "",
                            },
                            {
                              receiving2: "",
                              type2: "",
                              id: 2,
                              quantity2: "",
                              palletsNumber2: "",
                              numberFBA2: "",
                            },
                          ],
                        });
                        setTimeout(checkForm, 100);
                      }}
                      className="list"
                    >
                      Pre-Alert no #{alert.id}
                    </div>
                  );
                })
              : ""}
              {lastVisible && (
              <Button color="primary" onClick={fetchMoreAlerts} style={{ margin: '10px' }}>
              Wczytaj więcej
              </Button>
              )}
          </div>
        </div>
        <div
          style={{
            borderRadius: "8px",
            padding: "20px",
            width: "80%",
            marginLeft: "0.5rem",
            border: "1px solid #333",
          }}
          className="pre-alert-box"
        >
          <Modal isOpen={open} toggle={handleOpen} size="xl" style={{ maxWidth: "90vw" }} backdrop="static" keyboard={false}>
            <ModalBody
              style={{ width: "100%", maxHeight: "90vh", overflowY: "auto" }}
            >
              <div
                style={{
                  display: "flex",
                  flexFlow: "row nowrap",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                  height: "50px",
                }}
              >
                <IoClose
                  onClick={() => handleOpen()}
                  style={{
                    width: "35px",
                    height: "35px",
                    color: "#FFD814",
                    cursor: "pointer",
                  }}
                />
              </div>
              <div className="container text-left">
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Name and surname
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="nameAndSurname"
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    <strong>Comment:</strong>
                  </label>
                  <textarea
                    className="form-control"
                    style={{ paddingLeft: "12px", paddingTop: "2px" }}
                    id="formGroupExampleInput"
                    placeholder=""
                    name="comment"
                    value={
                      objectValue.comment === undefined
                        ? preAlert.comment
                        : objectValue.comment
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <Button
                  style={{ textTransform: "none" }}
                  onClick={() => handleCancel()}
                >
                  Cancel Pre-Alert
                </Button>
              </div>
            </ModalBody>
          </Modal>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h3>{title}</h3>
            <Button
              style={{ textTransform: "none" }}
              onClick={() => {
                dispatch(updateTitle(`Add new pre-alert`));
                dispatch(updatePreAlert({}));
              }}
            >
              Add new pre-alert
            </Button>
          </div>
          <div className="container text-left">
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                From
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder="Company Name"
                name="from"
                value={
                  objectValue.from !== undefined
                    ? objectValue.from
                    : Object.keys(preAlert).length > 0
                    ? preAlert.from
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput2" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="formGroupExampleInput2"
                placeholder="e.g. office@slampoland.pl"
                name="email"
                value={
                  objectValue.email !== undefined
                    ? objectValue.email
                    : Object.keys(preAlert).length > 0
                    ? preAlert.email
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualEmailValidate(e);
                }}
                required
              />
              {!emailValidate ? (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#CC0C39",
                    marginLeft: "2px",
                    marginTop: "5px",
                  }}
                >
                  Provide a valid email address
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Phone number
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder="+48 777 777 777"
                name="phoneNumber"
                value={
                  objectValue.phoneNumber !== undefined
                    ? objectValue.phoneNumber
                    : Object.keys(preAlert).length > 0
                    ? preAlert.phoneNumber
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Type of vehicle
              </label>
              <select
                className="form-control"
                id="type2"
                value={
                  objectValue.type !== undefined || objectValue.type === ""
                    ? objectValue.type
                    : Object.keys(preAlert).length > 0
                    ? preAlert.type
                    : ""
                }
                name="type"
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                type="text"
                required
              >
                <option></option>
                <option>trailer</option>
                <option>swapbody</option>
                <option>bus, van</option>
                <option>loose</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Truck plates
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="trailerPlates"
                value={
                  objectValue.trailerPlates !== undefined
                    ? objectValue.trailerPlates
                    : Object.keys(preAlert).length > 0
                    ? preAlert.trailerPlates
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            {objectValue.type === "loose" || preAlert.type === "loose" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput2" className="form-label">
                  Trailer type
                </label>
                <select
                  className="form-control"
                  id="type2"
                  name="trailerType"
                  value={
                    objectValue.trailerType !== undefined ||
                    objectValue.trailerType === ""
                      ? objectValue.trailerType
                      : Object.keys(preAlert).length > 0
                      ? preAlert.trailerType
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                  type="text"
                  required
                >
                  <option value="" disabled>Select...</option>
                  <option value="live">live</option>
                  <option value="drop">drop</option>
                </select>
              </div>
            ) : (
              ""
            )}
            {objectValue.type === "swapbody" ||
            objectValue.type === "trailer" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Trailer plate/swapbody #1
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="swapbodyPlates"
                  value={
                    objectValue.swapbodyPlates !== undefined
                      ? objectValue.swapbodyPlates
                      : Object.keys(preAlert).length > 0
                      ? preAlert.swapbodyPlates
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                  required
                />
              </div>
            ) : (
              ""
            )}
            {objectValue.type === "swapbody" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Swapbody #2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="swapbodyPlates2"
                  value={
                    objectValue.swapbodyPlates2 !== undefined
                      ? objectValue.swapbodyPlates2
                      : Object.keys(preAlert).length > 0
                      ? preAlert.swapbodyPlates2
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                />
              </div>
            ) : (
              ""
            )}
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                <strong>Delivery date:</strong>
              </label>
              <input
                type="datetime-local"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="firstDate"
                value={
                  objectValue.firstDate
                    ? objectValue.firstDate
                    : Object.keys(preAlert).length > 0
                    ? (() => {
                        const ms = getDateMs(preAlert.firstDate);
                        return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                      })()
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            <div className="row">
              <div className="col">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Receiving AMAZON-FC</th>
                      <th scope="col">FBA-Number</th>
                      <th scope="col">Quantity of units</th>
                      <th scope="col">No of pallets</th>
                    </tr>
                  </thead>
                  <tbody id="amazon-table">
                    <tr>
                      <th scope="row">
                        <input
                          className="form-control"
                          name="receiving"
                          value={
                            objectValue.cars && objectValue.cars[0] && objectValue.cars[0].receiving !== ""
                              ? objectValue.cars[0].receiving
                              : preAlert && preAlert.cars && preAlert.cars[0] && preAlert.cars[0].receiving
                              ? preAlert.cars[0].receiving
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          id="receive"
                          type="text"
                          required
                        />
                      </th>
                      <td>
                        <input
                          className="form-control"
                          id="fba-number"
                          value={
                            objectValue.cars && objectValue.cars[0] && objectValue.cars[0].numberFBA !== ""
                              ? objectValue.cars[0].numberFBA
                              : preAlert && preAlert.cars && preAlert.cars[0] && preAlert.cars[0].numberFBA
                              ? preAlert.cars[0].numberFBA
                              : ""
                          }
                          name="numberFBA"
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="text"
                          required
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="quantity-of-units"
                          value={
                            objectValue.cars && objectValue.cars[0] && objectValue.cars[0].quantity !== ""
                              ? objectValue.cars[0].quantity
                              : preAlert && preAlert.cars && preAlert.cars[0] && preAlert.cars[0].quantity
                              ? preAlert.cars[0].quantity
                              : ""
                          }
                          name="quantity"
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="number"
                          required
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="no-of-pallets"
                          name="palletsNumber"
                          value={
                            objectValue.cars && objectValue.cars[0] && objectValue.cars[0].palletsNumber !== "" &&
                            objectValue.cars[0].palletsNumber !== 0
                              ? objectValue.cars[0].palletsNumber
                              : preAlert && preAlert.cars && preAlert.cars[0] && preAlert.cars[0].palletsNumber
                              ? preAlert.cars[0].palletsNumber
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 1);
                            checkIndividualForm(e);
                          }}
                          type="number"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <input
                          className="form-control"
                          name="receiving"
                          value={
                            objectValue.cars && objectValue.cars[1] && objectValue.cars[1].receiving !== ""
                              ? objectValue.cars[1].receiving
                              : preAlert && preAlert.cars && preAlert.cars[1] && preAlert.cars[1].receiving
                              ? preAlert.cars[1].receiving
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          id="receive2"
                          type="text"
                          required={
                            objectValue.cars && objectValue.cars[1] &&
                            (objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0)
                              ? true
                              : false
                          }
                        />
                      </th>
                      <td>
                        <input
                          className="form-control"
                          id="fba-number2"
                          name="numberFBA"
                          value={
                            objectValue.cars && objectValue.cars[1] && objectValue.cars[1].numberFBA !== ""
                              ? objectValue.cars[1].numberFBA
                              : preAlert && preAlert.cars && preAlert.cars[1] && preAlert.cars[1].numberFBA
                              ? preAlert.cars[1].numberFBA
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          type="text"
                          required={
                            objectValue.cars && objectValue.cars[1] &&
                            (objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0)
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="quantity-of-units2"
                          name="quantity"
                          value={
                            objectValue.cars && objectValue.cars[1] &&
                            objectValue.cars[1].quantity !== "" &&
                            objectValue.cars[1].quantity !== 0
                              ? objectValue.cars[1].quantity
                              : preAlert && preAlert.cars && preAlert.cars[1] && preAlert.cars[1].quantity
                              ? preAlert.cars[1].quantity
                              : ""
                          }
                          onChange={(e) => {
                            handleUpdate(e, 2);
                          }}
                          type="number"
                          required={
                            objectValue.cars && objectValue.cars[1] &&
                            (objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0)
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          id="no-of-pallets2"
                          name="palletsNumber"
                          value={
                            objectValue.cars && objectValue.cars[1] &&
                            objectValue.cars[1].palletsNumber !== "" &&
                            objectValue.cars[1].palletsNumber !== 0
                              ? objectValue.cars[1].palletsNumber
                              : preAlert && preAlert.cars && preAlert.cars[1] && preAlert.cars[1].palletsNumber
                              ? preAlert.cars[1].palletsNumber
                              : ""
                          }
                          onChange={(e) => handleUpdate(e, 2)}
                          type="number"
                          required={
                            objectValue.cars && objectValue.cars[1] &&
                            (objectValue.cars[1].receiving !== "" ||
                            objectValue.cars[1].numberFBA !== "" ||
                            objectValue.cars[1].quantity !== 0 ||
                            objectValue.cars[1].palletsNumber !== 0)
                              ? true
                              : false
                          }
                        />
                      </td>
                    </tr>
                    {title === "Add new pre-alert" ? (
                      <>
                        {Array.from({ length: limitedFields }).map(
                          (_, index) => (
                            <tr>
                              <th scope="row">
                                <input
                                  className="form-control"
                                  name="receiving"
                                  value={
                                    objectValue.cars && objectValue.cars[index + 2]
                                      ? objectValue.cars[index + 2].receiving || ""
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  id="receive2"
                                  type="text"
                                />
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  id="fba-number2"
                                  name="numberFBA"
                                  value={
                                    objectValue.cars && objectValue.cars[index + 2]
                                      ? objectValue.cars[index + 2].numberFBA || ""
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="quantity-of-units2"
                                  name="quantity"
                                  value={
                                    objectValue.cars && objectValue.cars[index + 2]
                                      ? objectValue.cars[index + 2].quantity || ""
                                      : ""
                                  }
                                  onChange={(e) => {
                                    carsHandleUpdate(e, index + 2);
                                  }}
                                  type="number"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="no-of-pallets2"
                                  name="palletsNumber"
                                  value={
                                    objectValue.cars && objectValue.cars[index + 2]
                                      ? objectValue.cars[index + 2].palletsNumber || ""
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="number"
                                />
                              </td>
                            </tr>
                          )
                        )}
                        <tr>
                          <td style={{ padding: "5px" }}></td>
                          <td style={{ padding: "5px" }}></td>
                          <td style={{ padding: "5px" }}></td>
                          <td
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              padding: "5px",
                            }}
                          >
                            <FaPlus
                              style={{
                                cursor: "pointer",
                                width: "20px",
                                height: "20px",
                                color: "#ffc107",
                              }}
                              onClick={() => {
                                setFields(fields + 1);
                                addCar();
                              }}
                            />
                          </td>
                        </tr>
                      </>
                    ) : (
                      Array.from({ length: preAlert.cars.length - 2 }).map(
                        (_, index) => {
                          const carIndex = objectValue.cars.findIndex(
                            (car) => car.id === index + 3
                          );
                          const preAlertCarIndex = preAlert.cars.findIndex(
                            (car) => car.id === index + 3
                          );

                          return (
                            <tr>
                              <th scope="row">
                                <input
                                  className="form-control"
                                  name="receiving"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].receiving !== ""
                                      ? objectValue.cars[carIndex][
                                          `receiving${index + 3}`
                                        ]
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .receiving
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  id={`receiving${index + 3}`}
                                  type="text"
                                />
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  id="fba-number2"
                                  name="numberFBA"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].numberFBA !== ""
                                      ? objectValue.cars[carIndex].numberFBA
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .numberFBA
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="quantity-of-units2"
                                  name="quantity"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].quantity !== 0
                                      ? objectValue.cars[carIndex].quantity
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex].quantity
                                      : ""
                                  }
                                  onChange={(e) => {
                                    carsHandleUpdate(e, index + 2);
                                  }}
                                  type="number"
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  id="no-of-pallets2"
                                  name="palletsNumber"
                                  value={
                                    carIndex !== -1 &&
                                    objectValue.cars[carIndex] !== undefined &&
                                    objectValue.cars[carIndex].palletsNumber !==
                                      0
                                      ? objectValue.cars[carIndex].palletsNumber
                                      : preAlertCarIndex !== -1 &&
                                        Object.keys(preAlert).length > 0
                                      ? preAlert.cars[preAlertCarIndex]
                                          .palletsNumber
                                      : ""
                                  }
                                  onChange={(e) =>
                                    carsHandleUpdate(e, index + 2)
                                  }
                                  type="number"
                                />
                              </td>
                            </tr>
                          );
                        }
                      )
                    )}
                    <tr>
                      <th scope="row">Total</th>
                      <td></td>
                      <td className="total-td">{unitsTotal}</td>
                      <td className="total-td">{palletsTotal}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="formGroupExampleInput" className="form-label">
                Seal number #1
              </label>
              <input
                type="text"
                className="form-control"
                id="formGroupExampleInput"
                placeholder=""
                name="sealNumber"
                value={
                  objectValue.sealNumber !== undefined
                    ? objectValue.sealNumber
                    : Object.keys(preAlert).length > 0
                    ? preAlert.sealNumber
                    : ""
                }
                onChange={(e) => {
                  handleUpdate(e);
                  checkIndividualForm(e);
                }}
                required
              />
            </div>
            {objectValue.type === "swapbody" ? (
              <div className="mb-3">
                <label htmlFor="formGroupExampleInput" className="form-label">
                  Seal number #2
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="formGroupExampleInput"
                  placeholder=""
                  name="sealNumber2"
                  value={
                    objectValue.sealNumber2 !== undefined
                      ? objectValue.sealNumber2
                      : Object.keys(preAlert).length > 0
                      ? preAlert.sealNumber2
                      : ""
                  }
                  onChange={(e) => {
                    handleUpdate(e);
                    checkIndividualForm(e);
                  }}
                />
              </div>
            ) : (
              ""
            )}
            {preAlert &&
            preAlert.type === "swapbody" &&
            preAlert.arrivalDate &&
            preAlert.unloadingDate &&
            preAlert.completionUnloading &&
            preAlert.departureDate &&
            preAlert.vehicleRegistration ? (
              <>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Arrival date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="arrivalDate"
                    value={
                      objectValue.arrivalDate
                        ? objectValue.arrivalDate
                        : (() => {
                            const ms = getDateMs(preAlert.arrivalDate);
                            return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                          })()
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Start of unloading
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="unloadingDate"
                    value={
                      objectValue.unloadingDate
                        ? objectValue.unloadingDate
                        : (() => {
                            const ms = getDateMs(preAlert.unloadingDate);
                            return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                          })()
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Cancelation of unloading
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="unloadingDate"
                    value={
                      objectValue.unloadincagDate
                        ? objectValue.unloadingDate
                        : (() => {
                            const ms = getDateMs(preAlert.unloadingDate);
                            return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                          })()
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Departure date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="departureDate"
                    value={
                      objectValue.departureDate
                        ? objectValue.departureDate
                        : (() => {
                            const ms = getDateMs(preAlert.departureDate);
                            return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                          })()
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Vehicle registration
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="vehicleRegistration"
                    value={
                      objectValue.vehicleRegistration
                        ? objectValue.vehicleRegistration
                        : preAlert.vehicleRegistration
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Comments
                  </label>
                  <textarea
                    style={{ paddingLeft: "10px", paddingTop: "0px" }}
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="comment"
                    value={
                      objectValue.comment
                        ? objectValue.comment
                        : preAlert.comment
                        ? preAlert.comment
                        : ""
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
              </>
            ) : (
              ""
            )}
            {preAlert &&
            preAlert.type === "trailer" &&
            preAlert.arrivalDate &&
            preAlert.departureDate &&
            preAlert.vehicleRegistration ? (
              <>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Arrival date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="arrivalDate"
                    value={
                      objectValue.arrivalDate
                        ? objectValue.arrivalDate
                        : formatWarehouse(
                            new Date(
                              preAlert.arrivalDate.seconds * 1000 +
                                preAlert.arrivalDate.nanoseconds / 1000000
                            ),
                            "yyyy-MM-dd'T'HH:mm"
                          )
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="formGroupExampleInput" className="form-label">
                    Departure date
                  </label>
                  <input
                    type="datetime-local"
                    className="form-control"
                    id="formGroupExampleInput"
                    placeholder=""
                    name="departureDate"
                    value={
                      objectValue.departureDate
                        ? objectValue.departureDate
                        : (() => {
                            const ms = getDateMs(preAlert.departureDate);
                            return ms ? formatWarehouse(ms, "yyyy-MM-dd'T'HH:mm") : "";
                          })()
                    }
                    onChange={(e) => {
                      handleUpdate(e);
                      checkIndividualForm(e);
                    }}
                    required
                  />
                </div>
              </>
            ) : (
              ""
            )}
           </div>
           <div
  style={{
    width: "100%",
    height: "58px",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center" // Dodałem dla lepszego wyrównania
  }}
>
  <Button onClick={openModal} className="btn btn-error">
    Cancel
  </Button>

  {/* --- NOWE PRZYCISKI --- */}
  <Button 
    onClick={handleMarkAsRealized} 
    className="btn btn-success" 
    disabled={!preAlert || !preAlert.docId} // Przycisk jest nieaktywny, jeśli nic nie wybrano
  >
    Mark as Realized
  </Button>
  <Button 
    onClick={handleMarkAsNotArrived} 
    className="btn" 
    style={{ backgroundColor: '#FFC0CB', color: 'black' }} 
    disabled={!preAlert || !preAlert.docId} // Przycisk jest nieaktywny, jeśli nic nie wybrano
  >
    Mark as Not Arrived
  </Button>
  {/* --- KONIEC NOWYCH PRZYCISKÓW --- */}
  
  <Button
    onClick={
      title === "Add new pre-alert"
        ? sendPreAlert
        : handleUpdatePreAlert // Upewnij się, że używasz tutaj jednej, poprawionej funkcji
    }
    id="uppercase"
    className="btn btn-warning"
  >
    {title === "Add new pre-alert" ? "Add" : "Update"}
  </Button>
</div>
          <div>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-1"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                canceled
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-2"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                realized
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-3"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                after date
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-4"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                on OUT parking
              </p>
            </span>
            <span
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                alignItems: "center",
              }}
            >
              <div className="square-5"></div>
              <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>
                date changed
              </p>
            </span>
            <span style={{ display: "flex", flexFlow: "row nowrap", alignItems: "center" }}>
            <div className="square-6"></div> {/* Użyjemy nowej klasy CSS */}
            <p style={{ marginBottom: "0", marginLeft: "0.5rem" }}>Not Arrived</p>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PreAlertManagment;
